import * as Yup from 'yup';
// import _ from 'lodash';

const required = true;

export const newOperationModel = {
  stepOne: {
    firstName: {
      name: 'person_name',
      label: 'Nombre',
      requiredErrorMsg: 'Name is required',
      minErrorMsg: 'Name must be >2 chars',
      required,
    },
    lastName: {
      name: 'person_lastname',
      label: 'Apellido',
      requiredErrorMsg: 'Last Name is required',
      minErrorMsg: 'Last Name must be >2 chars',
      required,
    },
    document: {
      name: 'person_document',
      label: 'Documento',
      requiredErrorMsg: 'Document Name is required',
      required
    },
    email: {
      name: 'person_mail',
      label: 'E-mail',
      requiredErrorMsg: 'E-mail is required',
      required
    },
    documentType: {
      name: 'document_type',
      label: 'Tipo de documento',
      requiredErrorMsg: 'Document type Name is required',
      required
    },
    tributaryKey: {
      name: 'person_tributary_key',
      label: 'Id tributario'
    },
    tributaryType: {
      name: 'tributary_key_type',
      label: 'Tipo de id tributario'
    },
    clientNumber: {
      name: 'client_number',
      label: 'Número de cliente',
      requiredErrorMsg: 'Client number is required',
      required,
    },
    account: {
      name: 'account',
      label: 'Número de cuenta',
      requiredErrorMsg: 'Client account is required',
      required,
    },
    requestNumber: {
      name: 'request_number',
      label: 'Número de pedido de TC',
      requiredErrorMsg: 'TC number is required',
      required,
    },
    hash: {
      name: 'hash',
      label: 'Hash',
      requiredErrorMsg: 'Hash is required',
      required,
    },
    gender: {
      name: 'person_gender',
      label: 'Sexo',
      requiredErrorMsg: 'Gender is required',
      required
    },
    maritalStatus: {
      name: 'person_marital_status',
      label: 'Estado civil',
      requiredErrorMsg: 'Marital status is required',
      required
    },
    nationality: {
      name: 'person_nationality',
      label: 'Nacionalidad',
      requiredErrorMsg: 'Nationality is required',
      required
    },
    borndate: {
      name: 'person_borndate',
      label: 'Fecha de Nac.',
      requiredErrorMsg: 'Borndate is required',
      required
    },
    phone: {
      name: 'person_phone',
      label: 'Teléfono',
    },
    mobilePhone: {
      name: 'phone_type',
      label: 'Tipo de Teléfono',
      requiredErrorMsg: 'Mobile phone is required',
      required
    },
    deliverType: {
      name: 'deliver_type',
      label: 'Tipo de entrega'
    },
    street: {
      name: 'person_address_street',
      label: 'Calle'
    },
    streetType: {
      name: 'person_address_type',
      label: 'Tipo de Domicilio'
    },
    streetNumber: {
      name: 'person_address_number',
      label: 'Altura'
    },
    streetFloor: {
      name: 'person_address_floor',
      label: 'Piso'
    },
    streetDepartament: {
      name: 'person_address_departament',
      label: 'Departamento'
    },
    state: {
      name: 'person_address_province',
      label: 'Provincia'
    },
    country: {
      name: 'person_address_country',
      label: 'País'
    },
    sectorDate: {
      name: 'sector',
      label: 'Sector',
      required
    },
    county: {
      name: 'person_address_county',
      label: 'Localidad',
      required,
    },
    zipCode: {
      name: 'person_address_zipcode',
      label: 'Código postal',
      required,
    },
    reject: {
      name: 'Register fail',//'metadata.error.message'
      code: "3001", //'metadata.error.code' 
      label: 'Motivo del Rechazo',
      required,
    },
  },
  stepTwo: {
    batchNumber: {
      name: 'batch_number',
      label: 'Nro. lote',
      required,
    },
    batchDescription: {
      name: 'batch_description',
      label: 'Dscr. lote',
      required,
    },
    branchOffice: {
      name: 'branch',
      label: 'Sucursal',
      required,
    },
    branchAddress: {
      name: 'branch_address',
      label: 'Direccion de sucursal',
      required,
    },
    cardType: {
      name: 'card_brand',
      label: 'Tipo de TC',
      required,
      options: [
        { label: 'VISA', value: 'visa' },
        { label: 'MASTERCARD', value: 'mastercard' },
      ],
    },
    closing: {
      name: 'closing_date',
      label: 'Cierre',
      required,
    },
    paymentMethod: {
      name: 'payment_method',
      label: 'Metodo de pago',
      required,
      options: [
        { label: 'Debito automatico', value: 'debito en cuenta' },
        { label: 'En sucursal', value: 'sucursal' },
      ],
    },
    creditLimit: {
      name: 'purchase_limit',
      label: 'Límite de compra',
      required,
    },
    financingLimit: {
      name: 'financing_limit',
      label: 'Límite de financiación',
      required,
    },
    installmentsLimit: {
      name: 'fees_limit',
      label: 'Límite de cuotas',
      required,
    },
    advancementLimit: {
      name: 'advance_limit',
      label: 'Límite de adelanto',
      required,
    },
    contractDate: {
      name: 'contract_date',
      label: 'Fecha operacion',
      required,
    },
    place: {
      name: 'place',
      label: 'Lugar',
      required,
    },
    bcraCode: {
      name: 'bcra_activity_code',
      label: 'Actividad BCRA',
      required,
    },
    igSituacionCode: {
      name: 'ig_situation_code',
      label: 'Situacion impuestos a las ganancias',
      required,
    },
    ivaSituation: {
      name: 'iva_situation',
      label: 'Situacion de IVA',
      required,
    },
    ivaExtent: {
      name: 'iva_extent',
      label: 'Extención de IVA',
      required,
    },
    reason: {
      name: 'reason',
      label: 'Razón Social',
      required,
    }
  },

};

const {
  stepOne: {
    firstName,
    lastName,
    document,
    documentType,
    email,
    deliverType,
    tributaryKey,
    tributaryType,
    clientNumber,
    account,
    requestNumber,
    hash,
    gender,
    maritalStatus,
    nationality,
    borndate,
    phone,
    mobilePhone,
    street,
    streetNumber,
    streetFloor,
    streetDepartament,
    country,
    streetType,
    state,
    sectorDate,
    county,
    zipCode,
  },
  stepTwo: {
    batchNumber,
    batchDescription,
    branchOffice,
    branchAddress,
    cardType,
    closing,
    paymentMethod,
    creditLimit,
    financingLimit,
    installmentsLimit,
    advancementLimit,
    contractDate,
    place,
    ivaExtent,
    reason,
  },
} = newOperationModel;

export const newOperationInitialState = {
  stepOne: {
    [firstName.name]: '',
    [lastName.name]: '',
    [document.name]: '',
    [documentType.name]: '',
    [email.name]: '',
    [deliverType.name]: '',
    [tributaryKey.name]: '',
    [tributaryType.name]: '',
    [clientNumber.name]: '',
    [account.name]: '',
    [requestNumber.name]: '',
    [hash.name]: '',
    [gender.name]: '',
    [maritalStatus.name]: '',
    [nationality.name]: '',
    [borndate.name]: '',
    [phone.name]: '',
    [mobilePhone.name]: '',
    [street.name]: '',
    [streetType.name]: '',
    [streetNumber.name]: '',
    [streetFloor.name]: '',
    [streetDepartament.name]: '',
    [country.name]: '',
    [state.name]: '',
    [sectorDate.name]: '',
    [county.name]: '',
    [zipCode.name]: '',
  },
  stepTwo: {
    [batchNumber.name]: '',
    [batchDescription.name]: '',
    [branchOffice.name]: '',
    [branchAddress.name]: '',
    [cardType.name]: '',
    [closing.name]: '',
    [paymentMethod.name]: '',
    [creditLimit.name]: '',
    [financingLimit.name]: '',
    [installmentsLimit.name]: '',
    [advancementLimit.name]: '',
    [contractDate.name]: '',
    [place.name]: '',
    [ivaExtent.name]: '',
    [reason.name]: '',
  },
};

// TODO: add field validations
export const newOperationValidationSchema = Yup.object().shape({
  // Step One
  [firstName.name]: Yup.string(),
  [lastName.name]: Yup.string(),
  [document.name]: Yup.string().nullable(),
  [documentType.name]: Yup.string(),
  [email.name]: Yup.string().nullable(),
  [deliverType.name]: Yup.string().nullable(),
  [tributaryKey.name]: Yup.string(),
  [tributaryType.name]: Yup.string(),
  [clientNumber.name]: Yup.number(),
  [requestNumber.name]: Yup.string(),
  [hash.name]: Yup.string(),
  [gender.name]: Yup.string().nullable(),
  [nationality.name]: Yup.string().nullable(),
  [borndate.name]: Yup.string().nullable(),
  [phone.name]: Yup.string().nullable(),
  [mobilePhone.name]: Yup.string().nullable(),
  [street.name]: Yup.string().nullable(),
  [streetType.name]: Yup.string().nullable(),
  [streetNumber.name]: Yup.string().nullable(),
  [state.name]: Yup.string(),
  [sectorDate.name]: Yup.string(),
  [county.name]: Yup.string(),
  [zipCode.name]: Yup.string(),
  // Step Two
  [batchNumber.name]: Yup.number(),
  [batchDescription.name]: Yup.string(),
  [branchOffice.name]: Yup.string(),
  [branchAddress.name]: Yup.string(),
  [cardType.name]: Yup.string(),
  [closing.name]: Yup.string(),
  [paymentMethod.name]: Yup.string(),
  [creditLimit.name]: Yup.number(),
  [financingLimit.name]: Yup.number().nullable(),
  [installmentsLimit.name]: Yup.number().nullable(),
  [advancementLimit.name]: Yup.number().nullable(),
  [contractDate.name]: Yup.string(),
  [place.name]: Yup.string(),
  [ivaExtent.name]: Yup.string(),
});
